import React from 'react'

import styles from './index.module.scss'

const Loader = ({ testid }: { testid?: string }) => <div data-testid={testid} className={styles.loader} />

export default Loader
